/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

export default function CtrCantidadesReport() {

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={12}>
          <iframe width="100%" height="1080" src="https://reportes.sitesas.com/superset/dashboard/46/?native_filters_key=_WEEtEz90U79mMmB1mP06QpxwiNaxW7PnjbMyS7EtKktk_ZtBMXtUrzx26tolRtP&standalone=true" style={{ border: 0 }}></iframe>
        </Grid>
      </Grid>
      <Footer />
    </DashboardLayout>
  );
}

